import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { type DesligamentoQuery } from '@/core/types/graphql'
import { DESLIGAMENTO_QUERY } from '../data/desligamento'

export const useDesligamentos = () => {
  const { data: { desligamentos = [] } = {}, loading } =
    useQuery<DesligamentoQuery>(DESLIGAMENTO_QUERY, {
      fetchPolicy: 'network-only'
    })

  const desligamentosOptions = useMemo(
    () => desligamentos?.map(it => ({ label: it?.motivo, value: it?.id })),
    [desligamentos]
  )

  return {
    desligamentos,
    desligamentosOptions,
    hasDesligamentos: (desligamentos ?? []).length > 0,
    loading
  }
}
